export default {
    labos: [],
};